import { DefaultLocale } from "@/i18n/config";
import { getLocaleFromPath } from "@/lib/language";

// 具有 SEO TDK 的页面
export const SEO_ROUTES = [
  "home",
  "casino",
  "profile",
  "collections",
  "my-profile",
  "feedback",
  "personalized-game",
  "recent-game",
  "install",
  "wager-contest",
  "hot-game",
  "casual-games",
  "vip",
  "providers",
  "responsible",
  "bonus-center",
  "notify",
  "menu",
  "settings",
  "help",
  "bonus-game",
  "tournament",

  // V2 TDK 新增
  "affiliate",
  "promotion",
  "sponsorship",
  // "nobru",
  "reset",
  "bonus-rule",

  //! 体育, 详情页暂不使用 (皆需要带 id 或是 子路由位置)
  "sports",
  "game-list",
  "promotion-details",
  "bet-detail",
  "personalized",
] as const;

export type SEO_ROUTES_TYPES = (typeof SEO_ROUTES)[number];

export type SEO_TDK_MAPPING_TYPES = Record<
  SEO_ROUTES_TYPES,
  {
    title: string;
    description: string;
    keyword: string;
  }
>;

type ImageNameTypes =
  | "homePageImg"
  | "userProfile"
  | "userProfileImg"
  | "illustrativeImg"
  | "logo";

// 圖片 alt 替換
const imageAltMap = {
  en: {
    logo: "Eluck Casino logo",
    homePageImg: "homePageImg",
    userProfile: "userProfile",
    userProfileImg: "userProfileImg",
    illustrativeImg: "illustrativeImg",
  },
  es: {
    logo: "Logotipo de Eluck Casino",
    homePageImg: "Imagen de la página principal",
    userProfile: "Perfil del usuario",
    userProfileImg: "Imagen de perfil del usuario",
    illustrativeImg: "Imagen ilustrativa",
  },
  pt: {
    logo: "Logotipo da Eluck Cassino",
    homePageImg: "Imagem página inicial",
    userProfile: "Perfil do usuário",
    userProfileImg: "userProImagem de perfil do usuáriofileImg",
    illustrativeImg: "Imagem ilustrativa",
  },
  hk: {
    logo: "Eluck 賭場標誌",
    homePageImg: "首頁圖片",
    userProfile: "使用者個人檔案",
    userProfileImg: "使用者個人檔案圖片",
    illustrativeImg: "插圖 / 示意圖",
  },
};

export const getImageAltByLang = (imageName: ImageNameTypes) => {
  const lang = getLocaleFromPath(window.location.pathname) || DefaultLocale;
  return `${imageAltMap[lang as keyof typeof imageAltMap][imageName]} ${window.location.host}`;
};
